<p-tree
  class="w-full"
  filterPlaceholder="durchsuchen ..."
  styleClass="p-0 m-0 border-none"
  [filter]="true"
  [lazy]="false"
  emptyMessage="Keine Indikatoren gefunden ..."
  [(selection)]="selectedNode"
  selectionMode="single"
  (onNodeSelect)="treeNodeSelect($event)"
  (onNodeUnselect)="treeNodeSelect($event)"
  [value]="tree"
  [draggableNodes]="false"
  [droppableNodes]="false"
  [trackBy]="trackByNodeId">
  <ng-template pTemplate="category" let-node>
    <div class="cursor-pointer flex align-items-center gap-2 relative">
      <i
        class="tree-category-icon"
        [ngClass]="
          !node.expanded && node.children.length
            ? 'fas fa-folder'
            : node.expanded && node.children.length
              ? 'fas fa-folder-open'
              : 'fa-regular fa-folder'
        "></i>
      <span
        *ngIf="
          node.number &&
          globalsStore.activeCommune()?.atlasConfig?.showIndicatorNumbers !==
            false
        "
        class="folder-number"
        >{{ node.number }}</span
      >
      {{ node.label }}
    </div>
  </ng-template>
  <ng-template pTemplate="indicator-set" let-node>
    <div class="cursor-pointer flex align-items-center gap-2 relative">
      <i
        [ngClass]="
          node.expanded ? 'fas fa-ruler' : 'fas fa-ruler-combined'
        "></i>
      {{ node.label }}
    </div>
  </ng-template>

  <ng-template let-node pTemplate="indicator">
    <div class="flex gap-2 align-items-center">
      @if (cannotCombine(node); as because) {
        <div class="flex gap-2 align-items-center" [pTooltip]="because">
          <a class="cursor-pointer text-color-secondary">{{ node.label }}</a>
          <i class="fas fa-info-circle"></i>
        </div>
      } @else {
        <a class="cursor-pointer">{{ node.label }}</a>

        @if (
          widgetStore.isIndicatorInSelection(node._id) ||
          selection.includes(node._id)
        ) {
          <i class="fas fa-circle-check"></i>
        }
      }
    </div>
  </ng-template>
</p-tree>
